export const getters = {
    shoppingCart: state => state.shoppingCart,
    rosters: state => state.shoppingCart && state.shoppingCart.rosters,
    shoppingIndicator: state => state.shoppingIndicator,
    existCard: state => state.existCard,
    cardProvided: state => state.existCard && state.existCard.cardProvided,
    lastNumberExistCard: state => state.existCard && state.existCard.last4,
    isPaid : state => state.isPaid,
    couponCode : state => state.couponCode,
    freeActivity: state => state.freeActivity
};


// WEBPACK FOOTER //
// ./src/store/modules/shoppingCart/getters.js